import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "./client";

/**
 * The shared query client.
 *
 * Retry policy is deliberate: a 4xx is the caller's fault and will fail
 * identically on retry, so retrying only wastes time and multiplies error noise.
 * Only genuinely transient failures are retried.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status < 500) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false, // a financial write must never be retried automatically
    },
  },
});
